import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { GUIHeadlineLight, GUISubBox } from "./GameUIElements";
import styled from "styled-components";
import { notificationController } from "./NotificationController";
import { PastNotificationsItem } from "./PastNotificationsItem";
import { NotificationWindow } from "./NineSlices";
const NotificationContainer = styled(GUISubBox).withConfig({
  displayName: "PastNotifications__NotificationContainer",
  componentId: "sc-fjlbpr-0"
})(["max-height:350px;"]);
export const PastNotifications = observer(() => {
  const {
    t
  } = useTranslation();
  const notifications = notificationController.pastNotifications;
  return /*#__PURE__*/React.createElement(NotificationWindow, null, /*#__PURE__*/React.createElement(GUIHeadlineLight, null, t("game.past_notifications")), /*#__PURE__*/React.createElement(NotificationContainer, null, notifications.map(info => /*#__PURE__*/React.createElement(PastNotificationsItem, {
    key: info.id,
    info: info
  }))));
});